/**
 * Bounds that the database ALSO enforces.
 *
 * SQLite cannot add a constraint after the fact, so each of these is a CHECK in
 * `worker/migrations/0001_init.sql` first and a constant here second. The two
 * must agree exactly; `worker/test/schema/constants.test.ts` reads the stored
 * DDL and fails on drift.
 *
 * A number that only TypeScript cares about does NOT belong here: it lives
 * beside the code that uses it, the way `config.ts` keeps each setting's
 * `maxLength` on the spec it bounds. The test above only looks for a matching
 * CHECK, so a constant with no SQL counterpart would sit here unexamined.
 */
/** Max eSIMs in one order. `orders.quantity`. */
export const MAX_ORDER_QUANTITY = 10;
/** Ceiling on the crypto discount. `orders.discount_pct`. */
export const MAX_DISCOUNT_PCT = 90;
/**
 * Idempotency keys are bearer-grade: presenting one returns the order it
 * opened, so they carry the same entropy floor as the order code.
 * `orders.attempt_key`.
 */
export const ATTEMPT_KEY_MIN_LENGTH = 32;
export const ATTEMPT_KEY_MAX_LENGTH = 64;
/** `seo_pages.slug`, `slug_history.old_slug`, `article_i18n.slug`. */
export const SLUG_MAX_LENGTH = 80;
/**
 * `config.value`. The read path restates this bound rather than trusting the
 * column, so an oversized value cannot be stored and then silently read back as
 * the default, which looks to an operator like the setting was ignored.
 */
export const CONFIG_VALUE_MAX_LENGTH = 4000;
//# sourceMappingURL=limits.js.map